/* eslint-disable react/destructuring-assignment */
import React from "react";
import { string, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";
import Avatar from "pages/_components/Avatar";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import { useSelector } from "react-redux";
import { statusTagColor } from "util/debin";
import { useParams } from "react-router-dom";
import InfoTag from "../../_components/InfoTag";

const DataDebin = (props) => {
    const {
        debitAccount = props.debitAccount,
        availableBalance = props.availableBalance,
        sellerName = props.sellerName,
        sellerCuit = props.sellerCuit,
        amount = props.amount,
        solicitDate = props.solicitDate,
        dueDate = props.dueDate,
        debinId = props.debinId,
        sellerCbu = props.sellerCbu,
        alias = props.alias,
        bank = props.bank,
        concept = props.concept,
        description = props.description,
        reference = props.reference,
        curencySeller = props.curencySeller,
        curencyBuyer = props.curencySeller,
        isDesktop = props.isDesktop,
        isTRXPL = props.isTRXPL,
    } = props;
    const { id } = useParams();

    const { sentRequests } = useSelector((state) => state.debin);
    const receivedDebin = sentRequests?.debinList?.find((object) => object.id === id);

    const State = () => (
        <InfoTag
            type="info"
            message={receivedDebin?.status?.code}
            tagBackground={statusTagColor(receivedDebin?.status?.code)}
        />
    );

    const regexCuota = new RegExp(/^\d{3}\/\d{3}$/);
    const descriptionLabel = regexCuota.test(description) ? "tableHeader.quota" : "debin.description.label";

    return (
        <>
            <GridTable className="details debin-credin-list">
                <GridTable.Container columns={3} rows={1}>
                    <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                        <CustomData titleText="debin.dateExpitation" titleTextType="I18N" valueText={debitAccount} />
                    </GridTable.Data>
                    {!isTRXPL && (
                        <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} columnWidth={1}>
                            <CustomData
                                titleText="debin.avalable.balance"
                                titleTextType="I18N"
                                valueText={<FormattedAmount currency={curencyBuyer} quantity={availableBalance} />}
                            />
                        </GridTable.Data>
                    )}
                </GridTable.Container>
                <GridTable.Container>
                    <GridTable.Data className="flex" columnStart={1} rowStart={1} columnWidth={3} alignX="center">
                        <GridTable.Container className="info-seller" columnWidth={3} columns={3} rows={1}>
                            {!isDesktop && (
                                <GridTable.Data columnStart={1} rowStart={1} columnWidth={1} alignX="flex-end">
                                    <State />
                                </GridTable.Data>
                            )}

                            <GridTable.Data
                                className="flex align-items-end"
                                rowStart={isDesktop ? 1 : 2}
                                columnStart={1}
                                columnWidth={2}>
                                {isDesktop && <Avatar user={{ userFullName: sellerName, defaultAvatarId: 0 }} />}

                                <CustomData
                                    titleText="debin.seller"
                                    titleTextType="I18N"
                                    className="data-label-name"
                                    valueText={
                                        <>
                                            <CustomText className="data-label" text={`${sellerName} `} />
                                            {isDesktop && <CustomText className="regular" text={`${sellerCuit} `} />}
                                        </>
                                    }
                                />
                            </GridTable.Data>

                            {!isDesktop && (
                                <GridTable.Data rowStart={3} columnWidth={1}>
                                    <CustomData
                                        titleText="debin.cuit.cuil.label"
                                        titleTextType="I18N"
                                        valueText={sellerCuit}
                                    />
                                </GridTable.Data>
                            )}

                            <GridTable.Data rowStart={isDesktop ? 1 : 4} columnWidth={1}>
                                <CustomData
                                    titleText="debin.amount"
                                    titleTextType="I18N"
                                    valueText={<FormattedAmount currency={curencySeller} quantity={amount} />}
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>

                    <GridTable.Data className="flex" columnStart={1} rowStart={2} columnWidth={3}>
                        <hr className="dotted" />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={3} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.solicit.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={solicitDate} dateFormat="DD/MM/YYYY" />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 3 : 4}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.expirery.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={dueDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 3 : 5}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData titleText="debin.id" titleTextType="I18N" valueText={debinId} />
                    </GridTable.Data>
                    <GridTable.Data className="flex" columnStart={1} rowStart={isDesktop ? 4 : 6} columnWidth={3}>
                        <hr className="dotted" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 7} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData titleText="debin.cbu" titleTextType="I18N" valueText={sellerCbu} />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 5 : 8}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData titleText="debin.alias" titleTextType="I18N" valueText={alias} />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 5 : 9}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData titleText="debin.bank.branch" titleTextType="I18N" valueText={bank} />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 6 : 10} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData titleText="debin.concept.label" titleTextType="I18N" valueText={concept} />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 6 : 11}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData titleText={descriptionLabel} titleTextType="I18N" valueText={description} />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 6 : 12}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData titleText="debin.reference" titleTextType="I18N" valueText={reference} />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

DataDebin.propTypes = {
    debitAccount: string,
    availableBalance: string,
    sellerName: string,
    sellerCuit: string,
    amount: string,
    solicitDate: string,
    dueDate: string,
    debinId: string,
    sellerCbu: string,
    alias: string,
    bank: string,
    concept: string,
    description: string,
    reference: string,
    curencySeller: string,
    curencyBuyer: string,
    isDesktop: bool,
    isTRXPL: string.isRequired,
};

DataDebin.defaultProps = {
    debitAccount: "",
    availableBalance: "",
    sellerName: "",
    sellerCuit: "",
    amount: "",
    solicitDate: "",
    dueDate: "",
    debinId: "",
    sellerCbu: "",
    alias: "",
    bank: "",
    concept: "",
    description: "",
    reference: "",
    curencySeller: "",
    curencyBuyer: "",
    isDesktop: true,
};

export default DataDebin;
